// @flow strict

import * as React from 'react';
// import {} from '@ansarada/ace-react';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../styles.scss';

export const QuoteSummary = ({ values }: any) => {
  const clientName = `${values.InvoiceFirstName} ${values.InvoiceLastName}`;
  return (
    <div className={styles.summary}>
      <div className={styles.section}>
        <h2 className={styles.summaryTitle}>Your details</h2>
        <div className={styles.summaryContainer}>
          <div>{`${values.Firstname} ${values.Lastname}`}</div>
          <div>{values.Company}</div>
          <div>{values.Email}</div>
          <div>{values.PhoneNumber}</div>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.summaryTitle}>Your client&apos;s details</h2>
        <div className={styles.summaryContainer}>
          <div>{clientName.trim() === '' ? `Client's name` : clientName}</div>
          <div>{values.InvoiceCompany || `Client's company name`}</div>
          <div>{values.InvoiceAddress || `Client's address`}</div>
          <div>{values.InvoiceEmail || `Client's email`}</div>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.summaryTitle}>Quote details</h2>
        <div className={styles.summaryContainer}>
          <div>{values.DataPlan} data plan</div>
          <div>{values.SubscriptionPlan} duration</div>
        </div>
      </div>
    </div>
  );
};
